<template>
    <transition name="modal">
        <portal to="destination">
            <div class="modal-backdrop p-16 text-main-text " v-show="show" @click.self="$emit('close')">
                <div class="relative modal flex justify-center text-center flex-col  p-auto text-xm">
                    <button class="absolute pin-t pin-r outline-none m-6 z-40" @click="delete_modal = true">
                        <img class="h-4" src="@/assets/SVG/cross-partners.svg" />
                    </button>
                    <p class="pt-4"><span class="text-brand-light font-mediumBig">{{name}}</span>, ваши изменения будут</p>
                    <p class=""> внесены.</p>
                    <br>
                    <p>Наш администратор свяжется с вами для подтверждения информациию</p>

                </div>
            </div>
        </portal>
    </transition>
</template>

<script>
export default {
  props: {
    name: {
      type: String,
      default: 'Имя капитана',
    },
  },
  data() {
    return {
      ext: '',
      show: true,
    };
  },
  methods: {
    dismiss() {
      document.body.style.overflow = 'auto';
      this.$emit('close');
      return this.show === false;
    },
  },
  created() {
    document.body.style.overflow = 'hidden';
    const escapeHandler = (e) => {
      if (e.key === 'Escape' && this.show) {
        this.dismiss();
      }
    };
    document.addEventListener('keydown', escapeHandler);
    this.$once('hook:destroyed', () => {
      document.removeEventListener('keydown', escapeHandler);
      this.dismiss();
    });
  },
};

</script>

<style scoped>
    .modal-backdrop {
        position: fixed;
        top: 0;
        right: 0;
        bottom: 0;
        left: 0;
        overflow: auto;
        padding: 2rem;
        background-color: rgba(0, 0, 0, 0.5);
    }
    .modal {
        margin-left: auto;
        margin-right: auto;
        max-width: 1200px;
        margin-top: 2rem;
    }
    .modal {
        width: 25rem;
        height: 13rem;
        box-shadow: 0 15px 35px rgba(0, 0, 0, 0.3), 0 5px 15px rgba(0, 0, 0, 0.07);
        border-radius: 10px;
        background-color: #ffffff;
    }

</style>
